import * as React from 'react';
import { MarginProps } from 'styled-system';
import { flameTheme } from '@lightspeed/flame/Core';
import { Text, TextLink } from '@lightspeed/flame/Text';
import { IconExternalLink } from '@lightspeed/flame/Icon/ExternalLink';
import { DropdownContent } from '@lightspeed/flame/Dropdown';
import { ACTIONS_DROPDOWN } from 'pages/views/devices/types';
import { handleDisconnect } from '../../utils/handle-hub-disconnect';
import { StyledDropdown, UnstyledButton } from './ActionsDropdown.styles';

interface ActionsDropdownProps {
  learnMore?: string;
  children?: React.ReactChildren;
  type: ACTIONS_DROPDOWN;
  callback?: (() => void | undefined) | undefined;
}

const ActionsDropdown: React.FC<ActionsDropdownProps & Partial<MarginProps>> = ({
  type,
  learnMore,
  children,
  callback,
  ...restProps
}) => {
  const { colors, space } = flameTheme;

  return (
    // TODO: We need better types...
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: (Element | Element[] | null | un... Remove this comment to see the full error message
    <StyledDropdown buttonContent="Actions" variant="secondary" {...restProps}>
      {React.Children.map(children, child => (
        <DropdownContent>{child}</DropdownContent>
      ))}
      {learnMore ? (
        <DropdownContent justifyContent="space-between">
          <TextLink
            target="_blank"
            fontSize="small"
            style={{ display: 'flex', alignItems: 'center' }}
            color={colors.secondary}
            href={learnMore}
          >
            <Text mr={1}>Learn more</Text>
            <IconExternalLink size={space[2] as string} color={colors.secondary} />
          </TextLink>
        </DropdownContent>
      ) : null}
      <DropdownContent>
        <UnstyledButton
          data-test="disconnect-hub"
          onClick={() => {
            handleDisconnect(type);
            callback?.();
          }}
          variant="danger"
        >
          Disconnect
        </UnstyledButton>
      </DropdownContent>
    </StyledDropdown>
  );
};

export { ActionsDropdown };
